import MapboxDraw from '@mapbox/mapbox-gl-draw'
import { isActiveFeature, isInactiveFeature, isVertex, noTarget } from '@mapbox/mapbox-gl-draw/src/lib/common_selectors'
import cloneDeep from 'lodash.clonedeep'

import DirectSelectRouteModeCommon from './DirectSelectRouteModeCommon'

const DirectSelectZoneRouteMode = cloneDeep(MapboxDraw.modes.direct_select)

DirectSelectZoneRouteMode.clickInactive = function () {}

DirectSelectZoneRouteMode.clickNoTarget = function (state, e) {
  const feature = this.getFeature(state.featureId)
  if (!feature) return

  if (!e.originalEvent.ctrlKey && !e.originalEvent.metaKey) {
    this.clearSelectedCoordinates()
    return
  }

  if (feature.type === 'MultiLineString' || feature.type === 'MultiFeature') {
    const coords = feature.getCoordinates()
    const numLines = coords.length
    if (numLines > 0) {
      const lastLine = coords[numLines - 1]
      feature.addCoordinate(`${numLines - 1}.${lastLine.length}`, e.lngLat.lng, e.lngLat.lat)
    }
  } else if (feature.type === 'LineString') {
    const coords = feature.getCoordinates()
    feature.addCoordinate(coords.length, e.lngLat.lng, e.lngLat.lat)
  }

  if (this.map) {
    const featureGeoJSON = feature.toGeoJSON()
    this.map.fire('draw.update', {
      action: 'change_coordinates',
      features: [featureGeoJSON],
    })
    // Also fire route_click so ActiveRouteBufferOnMap (tempZoneRoute) updates immediately
    this.map.fire('draw.route_click', {
      feature: featureGeoJSON,
    })
  }
}

DirectSelectZoneRouteMode.onVertex = DirectSelectRouteModeCommon.onVertex

DirectSelectZoneRouteMode.onClick = DirectSelectRouteModeCommon.onClick

export default DirectSelectZoneRouteMode
